import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as actions from "../../../store/actions"
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Paper,
  IconButton,
  CircularProgress,
} from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';

import {
  DoneIconStyled, DivSubmitButtons, DivFormTitle,
} from './styles';

export default function TenantQRCodeOptions() {
  const dispatch = useDispatch();

  const tenant = useSelector(state => state.tenants.tenant);
  const loadingTenant = useSelector(state => state.tenants.loading);

  const [editMode, setEditMode] = useState(false);
  const [qrCodeOption, setQrCodeOption] = useState('');


  const updateTenants = async (tenantId, body) => dispatch(actions.updateTenantsSuperadmin(tenantId, body))

  useEffect(() => {
    if (tenant.qrCodeOption) {
        setQrCodeOption(tenant.qrCodeOption)
    }
  }, [tenant]);

  const handleChange = (event) => {
    setQrCodeOption(event.target.value);
  };

  const handleClose = () => {
    setQrCodeOption(tenant.qRcodeOption)
      setEditMode(false);
  }

  const handleSubmit = async () => {
      const body = {
        qrCodeOption,
      }

      try {
        await updateTenants(tenant._id, body)
        setEditMode(false);
      } catch (err) {
          console.log('err', err)
      }
  }

  return (
    <Paper style={{...styles.container, opacity: loadingTenant ? '0.3' : '1'}}>
      <DivFormTitle>
        <Typography variant='h6' style={styles.title}>Local exibido no QR Code</Typography>
          <DivSubmitButtons>
            {editMode ?
              <>
                <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                <IconButton onClick={handleSubmit} size="large"><DoneIconStyled /></IconButton>
              </> :
              <>
                <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
              </>
            }
          </DivSubmitButtons>
      </DivFormTitle>
        {loadingTenant &&
          <div style={styles.spinner}>
            <CircularProgress />
          </div>}
      <FormControl variant="standard" margin='normal' disabled={!editMode}>
        <RadioGroup
          value={qrCodeOption}
          onChange={handleChange}
        >
          <FormControlLabel
            value="path"
            control={<Radio disabled={!editMode} />}
            label="Exibir path (padrão)"
          />
          <FormControlLabel
            value="company"
            control={<Radio disabled={!editMode} />}
            label="Exibir path com empresa terceira"
          />
          <FormControlLabel
            value="site"
            control={<Radio disabled={!editMode} />}
            label="Exibir apenas site"
          />
        </RadioGroup>
      </FormControl>
    </Paper>
  );
}

const styles = {
  container: {
    padding: "1rem",
    margin: "1rem 0",
  },
  title: {
    marginBottom: "1rem",
  },
  spinner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    opacity: '1',
  },
};
